import React from 'react';
import { PORTRAIT_FRANK } from '../shared';

/**
 * Expert — founders intro, two stacked rows (second mirrored).
 * Auto-numbered when inside `.numbered-sections`.
 */
export default function Expert() {
  const experts = [
    {
      name: 'Dr. Frank Peter Balz',
      role: 'Geschäftsführer & Ihr Gesprächspartner für die Erstanalyse',
      img: PORTRAIT_FRANK,
      lead:
        'Frank Peter Balz bringt Erfahrungen aus Consulting, quantitativer Finanzprogrammierung, einem B2B-KI-Startup und der Verwaltung von Investmentimmobilien ein. Verantwortet Analyse und Immobilienstrategie sowie die Entwicklung der Software, mit der wir Ihr Portfolio steuern.',
      credentials: [
        'Ph.D. Strategic Management · HHL Leipzig Graduate School',
        'Operatives Asset Management, Consulting, Quantitative Finance',
        'verantwortet Analyse, Strategie & Systeme',
        'Gründer hamba GmbH (2020)',
      ],
    },
  ];

  return (
    <section id="founders" style={{ padding: '140px 0', background: 'var(--cream-deep)' }}>
      <div className="shell">
        <div className="section-label numbered reveal" style={{ marginBottom: 28 }}>
          <span>Über uns</span>
        </div>
        <h2 className="h-section reveal" style={{ marginBottom: 80, maxWidth: '20ch' }}>
          Wer wir sind.
        </h2>

        {experts.map((e, idx) => {
          const mirror = idx % 2 === 1;
          return (
            <div
              key={idx}
              style={{
                display: 'grid',
                gridTemplateColumns: 'minmax(280px, 380px) 1fr',
                gap: 80,
                alignItems: 'start',
                marginBottom: idx < experts.length - 1 ? 120 : 0,
                direction: mirror ? 'rtl' : 'ltr',
              }}
            >
              <div className="reveal" style={{ direction: 'ltr' }}>
                <div className="portrait" style={{ marginBottom: 20 }}>
                  <img
                    src={e.img}
                    alt={e.name}
                    style={{
                      position: 'absolute',
                      inset: 0,
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </div>
              </div>

              <div className="reveal" style={{ direction: 'ltr' }}>
                <h3
                  style={{
                    fontFamily: 'var(--serif)',
                    fontSize: 'clamp(32px, 3.4vw, 44px)',
                    lineHeight: 1.1,
                    color: 'var(--anthracite)',
                    marginBottom: 10,
                    letterSpacing: '-0.005em',
                  }}
                >
                  {e.name}
                </h3>
                <div
                  style={{
                    fontFamily: 'var(--serif)',
                    fontStyle: 'italic',
                    fontSize: 20,
                    color: 'var(--bordeaux)',
                    marginBottom: 14,
                  }}
                >
                  {e.role}
                </div>

                <p
                  className="body-prose"
                  style={{
                    fontSize: 19,
                    lineHeight: 1.7,
                    marginBottom: 24,
                    maxWidth: '60ch',
                  }}
                >
                  {e.lead}
                </p>

                <ul
                  style={{
                    listStyle: 'none',
                    padding: 0,
                    margin: 0,
                    borderTop: '1px solid var(--cream-line)',
                  }}
                >
                  {e.credentials.map((c, i) => (
                    <li
                      key={i}
                      style={{
                        padding: '14px 0',
                        borderBottom: '1px solid var(--cream-line)',
                        display: 'grid',
                        gridTemplateColumns: '32px 1fr',
                        gap: 16,
                        alignItems: 'baseline',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                          fontSize: 11,
                          letterSpacing: '0.1em',
                          color: 'var(--charcoal-faint)',
                        }}
                      >
                        {String(i + 1).padStart(2, '0')}
                      </span>
                      <span
                        style={{
                          fontFamily: 'var(--serif)',
                          fontSize: 18,
                          color: 'var(--anthracite)',
                        }}
                      >
                        {c}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
